/**
 * Validatore lato client per gli import CSV/Excel.
 *
 * Perché è nel client: su Android il picker dei file usa `accept` come
 * filtro MIME e i CSV finiscono spesso con MIME "sbagliati" (octet-stream,
 * vnd.ms-excel, o addirittura vuoto) → l'elenco si azzera e l'utente non
 * vede NIENTE. Per questo il campo <input type="file"> nell'app non ha
 * `accept`: mostra tutti i file, e il controllo di validità lo facciamo
 * qui sull'ESTENSIONE (il MIME del telefono non è affidabile).
 *
 * La validazione del CONTENUTO è responsabilità del backend, che risponde
 * con "Errore lettura file: ..." se pandas non riesce a interpretarlo.
 */

export const IMPORT_ACCEPTED_EXT = [".csv", ".xlsx", ".xls"];
export const IMPORT_ACCEPTED_LABEL = "CSV, XLSX o XLS";
export const IMPORT_MAX_MB = 25;

function _ext(name) {
  const s = String(name || "").toLowerCase();
  const dot = s.lastIndexOf(".");
  return dot >= 0 ? s.slice(dot) : "";
}

/**
 * @param {File | null | undefined} file
 * @returns {{ ok: true } | { ok: false, message: string }}
 */
export function validateImportFile(file) {
  if (!file) {
    return { ok: false, message: "Nessun file selezionato." };
  }
  const ext = _ext(file.name);
  if (!IMPORT_ACCEPTED_EXT.includes(ext)) {
    const shown = ext ? `“${ext}”` : "senza estensione";
    return {
      ok: false,
      message: `Formato file non supportato (${shown}). Accettati: ${IMPORT_ACCEPTED_LABEL}.`,
    };
  }
  if (typeof file.size === "number" && file.size === 0) {
    return {
      ok: false,
      message: `Il file “${file.name}” è vuoto. Riesporta il file e riprova.`,
    };
  }
  const maxBytes = IMPORT_MAX_MB * 1024 * 1024;
  if (typeof file.size === "number" && file.size > maxBytes) {
    return {
      ok: false,
      message: `Il file è troppo grande (max ${IMPORT_MAX_MB} MB). Dividi l'import in più file.`,
    };
  }
  return { ok: true };
}

/**
 * Estrae un messaggio d'errore utile dall'errore Axios/fetch dell'import.
 * Se il backend ha risposto con "Errore lettura file: ..." lo restituisce
 * intatto (già in italiano). Altrimenti aggiunge un suffisso che ricorda
 * i formati accettati.
 */
export function describeImportError(err) {
  const detail =
    err?.response?.data?.detail ||
    err?.data?.detail ||
    err?.message ||
    "Errore sconosciuto";
  const s = String(detail);
  if (/formato/i.test(s) || /lettura file/i.test(s)) return s;
  return `${s}. Formati accettati: ${IMPORT_ACCEPTED_LABEL}.`;
}
